function r(e) {
  return function(n) {
    return n == null ? void 0 : n[e];
  };
}
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseProperty.js
// module id = 1443
// module chunks = 41